import { useEffect, useState } from 'react';
import { useGetLmsActiveNewsQuery } from '../../../../api';

const INITIAL_FILTERS = { search: '', planningLocation: null, trainingType: null, sortOrder: 'desc' };
const SEARCH_DEBOUNCE_MS = 400;

const useLmsNewsData = () => {
    const [lazyParams, setLazyParams] = useState({ first: 0, rows: 12, page: 1 });
    const [filters, setFilters] = useState(INITIAL_FILTERS);
    const [searchInput, setSearchInput] = useState('');

    useEffect(() => {
        const timer = setTimeout(() => {
            setFilters((prev) => (prev.search === searchInput.trim() ? prev : { ...prev, search: searchInput.trim() }));
            setLazyParams((prev) => (prev.page === 1 ? prev : { ...prev, first: 0, page: 1 }));
        }, SEARCH_DEBOUNCE_MS);
        return () => clearTimeout(timer);
    }, [searchInput]);

    const { data, isLoading, isFetching } = useGetLmsActiveNewsQuery(
        {
            search: filters.search,
            planningLocation: filters.planningLocation,
            trainingType: filters.trainingType,
            sortOrder: filters.sortOrder,
            pageNumber: lazyParams.page,
            pageSize: lazyParams.rows
        },
        { refetchOnMountOrArgChange: true }
    );

    const handleFilterChange = (field, value) => {
        setFilters((prev) => ({ ...prev, [field]: value ?? null }));
        setLazyParams((prev) => ({ ...prev, first: 0, page: 1 }));
    };

    const onPage = (event) => {
        setLazyParams((prev) => ({ ...prev, page: event.page + 1, first: event.first, rows: event.rows }));
    };

    const onRowsChange = (rows) => {
        setLazyParams({ first: 0, page: 1, rows });
    };

    const clearFilters = () => {
        setSearchInput('');
        setFilters(INITIAL_FILTERS);
        setLazyParams((prev) => ({ ...prev, first: 0, page: 1 }));
    };

    const hasActiveFilters = !!(searchInput || filters.planningLocation || filters.trainingType || filters.sortOrder !== INITIAL_FILTERS.sortOrder);

    return {
        items: data?.items || [],
        totalCount: data?.totalCount || 0,
        isLoading,
        isFetching,
        lazyParams,
        onPage,
        onRowsChange,
        filters,
        searchInput,
        setSearchInput,
        handleFilterChange,
        clearFilters,
        hasActiveFilters
    };
};

export default useLmsNewsData;
